import React, { Component } from 'react';

import List from "../common/List";
import ProductListItem from '../common/ProductListItem';
import { FormattedMessage } from 'react-intl';
import api from "../../config/api";
import { completeUrls } from "../../util/utils";
import SearchForm from "../form/SearchForm";

class ProductMultiPage extends Component {

	/**
	 * Initialize ProductPage
	 */
	constructor(){
		super();
		this.state = {
			products: [],
			titleClass: 'page__title',
			contentClass: 'page__content'
		};
	}

	/**
	 * Load the products on first mount
	 */
	componentDidMount(){
		const {selectedLanguage, categories} = this.props;
		categories.map(category =>
			this.loadProducts(api.product(selectedLanguage.codeCountry,category),selectedLanguage,category));
	}

	/**
	 * Load other products if the route is changed
	 * @param nextProps - the props that will be received next
	 */
	componentWillReceiveProps(nextProps) {
		if(this.props.match.url !== nextProps.match.url) {
			this.setState({products: []});
			nextProps.categories.map(category =>
				this.loadProducts(api.product(nextProps.selectedLanguage.codeCountry,category),nextProps.selectedLanguage,category));
		}
	}

	/**
	 * Load products from generated api uri
	 */
	loadProducts = (uri, selectedLanguage, category) => {
		const { products } = this.state;

		fetch(uri)
			.then(res => res.json())
			.then(data => {
				const items = completeUrls(data);
				products.push({
					title: category,
					items: items,
				});
				this.setState({products});
			})
			.catch(err => console.error(err));
	};

	/**
	 * Render one product item
	 *
	 * @param product - one product to be rendered
	 * @returns {XML}
	 */
	renderProductList = (product) => {
		const {localizePath} = this.props;
		return (
			<ProductListItem
				key={product.id}
				product={product}
				localizePath={localizePath}
			/>
		);
	};

	renderProductMultiList = (product) => {
		return (
			<div className="product-list__category" key={product.title}>
				<h3 className="product-list__category-title">
					<FormattedMessage id={"page.title." + product.title.toLowerCase().replace(/_/g,"-")} />
				</h3>
				<List className="product-list product-list--main-page"
				      items={product.items.sort((a,b) => a.name.localeCompare(b.name)).map(this.renderProductList)}/>
			</div>
		);
	};

	/**
	 * Get product store from localStorage
	 * @returns {Map}
	 */
	getProductStore = () => {
		const productStore = localStorage.getItem('productStore');
		return productStore === null ? new Map() : new Map(JSON.parse(productStore));
	};

	/**
	 * Set product store to localStorage
	 * @param value
	 */
	setProductStore = (value) => {
		localStorage.setItem('productStore', JSON.stringify([...value]));
	};

	/**
	 * Render ProductPage
	 *
	 * @returns {XML}
	 */
	render() {
		const {contentClass, products} = this.state;
		const {code, banner} = this.props;
		const bannerClassName = banner
			? 'page__banner ' + banner
			: 'page__banner';

		return (
			<div className="container-flex">
				<div className={bannerClassName}>
					<h2>
						<FormattedMessage id={"page.title." + code.toLowerCase().replace(/_/g,"-")} />
					</h2>
				</div>
				<SearchForm {...this.props} />
				<div className="page">
					<div className={contentClass}>
						{products.sort((a,b) => a.title.localeCompare(b.title)).map(this.renderProductMultiList)}
					</div>
				</div>
			</div>
		);
	}
}

export default ProductMultiPage;


// WEBPACK FOOTER //
// ./src/components/page/ProductMultiPage.js